// // import React, { useState, useRef } from 'react';
// // import { FaCertificate } from 'react-icons/fa';
// // import AddCertificateForm from '../AddCertificateForm/AddCertificateForm';
// // import CertificateTemplate from '../CertificateTemplate/CertificateTemplate';
// // import CertificateList from '../CertificateList/CertificateList';
// // import html2canvas from 'html2canvas';
// // import jsPDF from 'jspdf';

// // const Certificate = () => {
// //   const [view, setView] = useState('form');
// //   const [activeCert, setActiveCert] = useState(null);
// //   const certRef = useRef(null);

// //   const handleSaved = (savedCertificate) => {
// //     setActiveCert(savedCertificate);
// //     setView('preview');
// //   };

// //   const handleDownload = async () => {
// //     if (!certRef.current) return;

// //     const canvas = await html2canvas(certRef.current, { scale: 2 });
// //     const imgData = canvas.toDataURL('image/png');

// //     // Determine orientation based on the certificate's aspect ratio
// //     const orientation = canvas.width > canvas.height ? 'landscape' : 'portrait';

// //     const pdf = new jsPDF({
// //       orientation,
// //       unit: 'px',
// //       format: [canvas.width, canvas.height],
// //     });

// //     pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);
// //     pdf.save(`${activeCert.studentName.replace(/\s+/g, '_')}_certificate.pdf`);
// //   };

// //   return (
// //     <div>
// //       <div className="card ctm-border-radius shadow-sm bg-white card grow mb-3">
// //         <div className="card-body">
// //           <ul className="list-group list-group-horizontal-lg">
// //             <li className={`list-group-item text-center button-5 ${view === 'form' ? 'active' : ''}`}>
// //               <a
// //                 href="#"
// //                 className={view === 'form' ? 'text-white' : 'text-dark'}
// //                 onClick={(e) => { e.preventDefault(); setView('form'); }}
// //               >
// //                 <FaCertificate /> Add Student
// //               </a>
// //             </li>
// //             <li className={`list-group-item text-center button-6 ${view === 'list' ? 'active' : ''}`}>
// //               <a
// //                 href="#"
// //                 className={view === 'list' ? 'text-white' : 'text-dark'}
// //                 onClick={(e) => { e.preventDefault(); setView('list'); }}
// //               >
// //                 <FaCertificate /> All Certificates
// //               </a>
// //             </li>
// //           </ul>
// //         </div>
// //       </div>

// //       {view === 'form' && <AddCertificateForm onSaved={handleSaved} />}

// //       {/* {view === 'preview' && activeCert && (
// //         <div className="card ctm-border-radius shadow-sm grow">
// //           <div className="card-body text-center">
// //             <h4 className="text-dark mb-4">Preview & Generate Certificate</h4>

// //             <div
// //               style={{
// //                 overflowX: 'auto',
// //                 width: '100%',
// //                 display: 'flex',
// //                 justifyContent: 'flex-start',
// //               }}
// //             >
// //               <CertificateTemplate data={activeCert} ref={certRef} />
// //             </div>

// //             <div className="mt-4">
// //               <button className="btn btn-success me-2" onClick={handleDownload}>
// //                 Generate & Download Certificate
// //               </button>
// //               <button className="btn btn-outline-secondary" onClick={() => setView('form')}>
// //                 Add Another Student
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       )} */}
// // {view === 'preview' && activeCert && (
// //   <div className="cert-preview-wrapper ctm-border-radius shadow-sm grow">
// //     <div className="card-body text-center">
// //       <h4 className="text-dark mb-4">Preview & Generate Certificate</h4>

// //       <div
// //         style={{
// //           overflowX: 'auto',
// //           width: '100%',
// //           display: 'flex',
// //           justifyContent: 'flex-start',
// //         }}
// //       >
// //       <CertificateTemplate data={activeCert} ref={certRef} /> 
// //       </div>

// //       <div className="mt-4">
// //         <button className="btn btn-success me-2" onClick={handleDownload}>
// //           Generate & Download Certificate
// //         </button>
// //         <button className="btn btn-outline-secondary" onClick={() => setView('form')}>
// //           Add Another Student
// //         </button>
// //       </div>
// //     </div>
// //   </div>
// // )}
// //       {view === 'list' && <CertificateList onSelect={(cert) => { setActiveCert(cert); setView('preview'); }} />}
// //     </div>
// //   );
// // };

// // export default Certificate;













// ///sagar
// ///sagar
// import React, { useState, useRef, useEffect } from "react";
// import { FaCertificate } from "react-icons/fa";
// import AddCertificateForm from "../AddCertificateForm/AddCertificateForm";
// import CertificateTemplate from "../CertificateTemplate/CertificateTemplate";
// import CertificateList from "../CertificateList/CertificateList";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";

// const Certificate = () => {
//   const [view, setView] = useState("form");
//   const [activeCert, setActiveCert] = useState(null);

//   // Ref for the VISIBLE preview (this one can be scaled for display only)
//   const previewRef = useRef(null);

//   // Ref for a HIDDEN, always-100%-scale copy used ONLY for html2canvas capture.
//   // Because html2canvas does not reliably support the CSS `zoom` property (and
//   // can get confused capturing an element nested inside a zoomed/transformed
//   // parent), we keep a separate untouched full-size node just for downloading.
//   const downloadRef = useRef(null);

//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);

//   useEffect(() => {
//     const handleResize = () => {
//       setScreenWidth(window.innerWidth);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // Convert the old "zoom" percentages into a numeric scale factor for transform.
//   const scale =
//     screenWidth >= 1920
//       ? 0.8
//       : screenWidth >= 1600
//         ? 0.7
//         : screenWidth >= 1400
//           ? 0.6
//           : screenWidth >= 1200
//             ? 0.5
//             : screenWidth >= 992
//               ? 0.25
//               : 0.15;

//   const handleSaved = (savedCertificate) => {
//     setActiveCert(savedCertificate);
//     setView("preview");
//   };



//   const handleDownload = async () => {
//     if (!downloadRef.current || !activeCert) return;

//     // Capture from the hidden, full-size, unscaled node — never the scaled preview.
//     const canvas = await html2canvas(downloadRef.current, {
//       scale: 2,
//       useCORS: true,
//       backgroundColor: "#ffffff",
//       windowWidth: downloadRef.current.scrollWidth,
//       windowHeight: downloadRef.current.scrollHeight,
//     });
//     const imgData = canvas.toDataURL("image/png");

//     const orientation = canvas.width > canvas.height ? "landscape" : "portrait";

//     const pdf = new jsPDF({
//       orientation,
//       unit: "px",
//       format: [canvas.width, canvas.height],
//     });

//     pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
//     pdf.save(`${activeCert.studentName.replace(/\s+/g, "_")}_certificate.pdf`);
//   };

//   return (
//     <div>
//       <div className="card ctm-border-radius shadow-sm bg-white card grow mb-3">
//         <div className="card-body">
//           <ul className="list-group list-group-horizontal-lg">
//             <li
//               className={`list-group-item text-center button-5 ${view === "form" ? "active" : ""}`}
//             >
//               <a
//                 href="#"
//                 className={view === "form" ? "text-white" : "text-dark"}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   setView("form");
//                 }}
//               >
//                 <FaCertificate /> Add Student
//               </a>
//             </li>
//             <li
//               className={`list-group-item text-center button-6 ${view === "list" ? "active" : ""}`}
//             >
//               <a
//                 href="#"
//                 className={view === "list" ? "text-white" : "text-dark"}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   setView("list");
//                 }}
//               >
//                 <FaCertificate /> All Certificates
//               </a>
//             </li>
//           </ul>
//         </div>
//       </div>

//       {view === "form" && <AddCertificateForm onSaved={handleSaved} />}

//       {view === "preview" && activeCert && (
//         <div>
//           <div className="card-body text-center">
//             <h4 className="text-dark mb-4">Preview & Generate Certificate</h4>

//             {/* VISIBLE preview - scaled with transform (not zoom) purely for on-screen display */}
//             <div
//               className="mx-auto"
//               style={{
//                 width: `${1493 * scale}px`,
//                 height: `${1057 * scale}px`,
//                 overflow: "hidden",
//               }}
//             >
//               <div
//                 style={{
//                   transform: `scale(${scale})`,
//                   transformOrigin: "top left",
//                 }}
//               >
//                 <CertificateTemplate data={activeCert} ref={previewRef} />
//               </div>
//             </div>

//             <div
//               style={{
//                 zoom: screenWidth < 600 ? "70%" : "100%",
//               }}
//               className="flex *:text-sm w-screen flex-wrap items-center justify-center gap-x-3 mt-4"
//             >
//               <button
//                 className="border border-gray-300 hover:bg-gray-100 text-gray-800 font-medium py-2 px-4 rounded-lg whitespace-nowrap transition-colors"
//                 onClick={handleDownload}
//               >
//                 Download Certificate
//               </button>
//               <button
//                 className="border border-gray-300 hover:bg-gray-100 text-gray-800 font-medium py-2 px-4 rounded-lg whitespace-nowrap transition-colors"
//                 onClick={() => setView("form")}
//               >
//                 Add Student
//               </button>
//             </div>
//           </div>

//           {/*
//             HIDDEN full-size (100%) copy used only for PDF capture.
//             Positioned off-screen (not display:none, since some browsers/html2canvas
//             skip layout for display:none elements) so it always renders at native
//             1493x1057 size regardless of whatever scale the visible preview uses.
//           */}
//           <div
//             style={{
//               position: "fixed",
//               top: 0,
//               left: "-99999px",
//               zIndex: -1,
//             }}
//             aria-hidden="true"
//           >
//             <CertificateTemplate data={activeCert} ref={downloadRef} />
//           </div>
//         </div>
//       )}

//       {view === "list" && (
//         <CertificateList
//           onSelect={(cert) => {
//             setActiveCert(cert);
//             setView("preview");
//           }}
//         />
//       )}
//     </div>
//   );
// };

// export default Certificate;









// import React, { useState, useRef, useEffect } from "react";
// import { FaCertificate } from "react-icons/fa";
// import AddCertificateForm from "../AddCertificateForm/AddCertificateForm";
// import CertificateTemplate from "../CertificateTemplate/CertificateTemplate";
// import CertificateList from "../CertificateList/CertificateList";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";

// const Certificate = () => {
//   const [view, setView] = useState("form");
//   const [activeCert, setActiveCert] = useState(null);
//   const [editingCert, setEditingCert] = useState(null); // cert being edited, or null for "add new"
//   const [deleting, setDeleting] = useState(false);

//   const previewRef = useRef(null);
//   const downloadRef = useRef(null);
//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);

//   useEffect(() => {
//     const handleResize = () => setScreenWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const scale =
//     screenWidth >= 1920 ? 0.8
//     : screenWidth >= 1600 ? 0.7
//     : screenWidth >= 1400 ? 0.6
//     : screenWidth >= 1200 ? 0.5
//     : screenWidth >= 992 ? 0.25
//     : 0.15;

//   const handleSaved = (savedCertificate) => {
//     setActiveCert(savedCertificate);
//     setEditingCert(null);
//     setView("preview");
//   };

//   const handleEditClick = (cert) => {
//     setEditingCert(cert);
//     setView("form");
//   };

//   const handleCancelEdit = () => {
//     setEditingCert(null);
//     setView(activeCert ? "preview" : "list");
//   };

//   const handleDelete = async () => {
//     if (!activeCert) return;
//     if (!window.confirm("Delete this certificate? This cannot be undone.")) return;

//     setDeleting(true);
//     try {
//       const res = await fetch(`/api/certificates/${activeCert.certId}`, { method: "DELETE" });
//       if (!res.ok) throw new Error("Failed to delete certificate");
//       setActiveCert(null);
//       setView("list");
//     } catch (err) {
//       alert(err.message || "Failed to delete certificate.");
//     } finally {
//       setDeleting(false);
//     }
//   };

//   const handleDownload = async () => {
//     if (!downloadRef.current || !activeCert) return;
//     const canvas = await html2canvas(downloadRef.current, {
//       scale: 2,
//       useCORS: true,
//       backgroundColor: "#ffffff",
//       windowWidth: downloadRef.current.scrollWidth,
//       windowHeight: downloadRef.current.scrollHeight,
//     });
//     const imgData = canvas.toDataURL("image/png");
//     const orientation = canvas.width > canvas.height ? "landscape" : "portrait";
//     const pdf = new jsPDF({ orientation, unit: "px", format: [canvas.width, canvas.height] });
//     pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
//     pdf.save(`${activeCert.studentName.replace(/\s+/g, "_")}_certificate.pdf`);
//   };

//   return (
//     <div>
//       <div className="card ctm-border-radius shadow-sm bg-white card grow mb-3">
//         <div className="card-body">
//           <ul className="list-group list-group-horizontal-lg">
//             <li className={`list-group-item text-center button-5 ${view === "form" ? "active" : ""}`}>
              
//                <a href="#"
//                 className={view === "form" ? "text-white" : "text-dark"}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   setEditingCert(null);
//                   setView("form");
//                 }}
//               >
//                 <FaCertificate /> Add Student
//               </a>
//             </li>
//             <li className={`list-group-item text-center button-6 ${view === "list" ? "active" : ""}`}>
              
//                 <a href="#"
//                 className={view === "list" ? "text-white" : "text-dark"}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   setView("list");
//                 }}
//               >
//                 <FaCertificate /> All Certificates
//               </a>
//             </li>
//           </ul>
//         </div>
//       </div>

//       {view === "form" && (
//         <AddCertificateForm
//           onSaved={handleSaved}
//           initialData={editingCert}
//           onCancel={editingCert ? handleCancelEdit : undefined}
//         />
//       )}

//       {view === "preview" && activeCert && (
//         <div>
//           <div className="card-body text-center">
//             <h4 className="text-dark mb-4">Preview & Generate Certificate</h4>

//             <div
//               className="mx-auto"
//               style={{ width: `${1493 * scale}px`, height: `${1057 * scale}px`, overflow: "hidden" }}
//             >
//               <div style={{ transform: `scale(${scale})`, transformOrigin: "top left" }}>
//                 <CertificateTemplate data={activeCert} ref={previewRef} />
//               </div>
//             </div>

//             <div
//               style={{ zoom: screenWidth < 600 ? "70%" : "100%" }}
//               className="flex *:text-sm w-screen flex-wrap items-center justify-center gap-x-3 mt-4"
//             >
//               <button
//                 className="border border-gray-300 hover:bg-gray-100 text-gray-800 font-medium py-2 px-4 rounded-lg whitespace-nowrap transition-colors"
//                 onClick={handleDownload}
//               >
//                 Download Certificate
//               </button>
//               <button
//                 className="border border-amber-400 hover:bg-amber-50 text-amber-700 font-medium py-2 px-4 rounded-lg whitespace-nowrap transition-colors"
//                 onClick={() => handleEditClick(activeCert)}
//               >
//                 Edit
//               </button>
//               <button
//                 className="border border-red-400 hover:bg-red-50 text-red-700 font-medium py-2 px-4 rounded-lg whitespace-nowrap transition-colors disabled:opacity-50"
//                 onClick={handleDelete}
//                 disabled={deleting}
//               >
//                 {deleting ? "Deleting..." : "Delete"}
//               </button>
//               <button
//                 className="border border-gray-300 hover:bg-gray-100 text-gray-800 font-medium py-2 px-4 rounded-lg whitespace-nowrap transition-colors"
//                 onClick={() => {
//                   setEditingCert(null);
//                   setView("form");
//                 }}
//               >
//                 Add Student
//               </button>
//             </div>
//           </div>

//           <div style={{ position: "fixed", top: 0, left: "-99999px", zIndex: -1 }} aria-hidden="true">
//             <CertificateTemplate data={activeCert} ref={downloadRef} />
//           </div>
//         </div>
//       )}

//       {view === "list" && (
//         <CertificateList
//           onSelect={(cert) => {
//             setActiveCert(cert);
//             setView("preview");
//           }}
//           onEdit={handleEditClick}
//         />
//       )}
//     </div>
//   );
// };

// export default Certificate;








// import React, { useState, useRef, useEffect } from "react";
// import { FaCertificate } from "react-icons/fa";
// import AddCertificateForm from "../AddCertificateForm/AddCertificateForm";
// import CertificateTemplate from "../CertificateTemplate/CertificateTemplate";
// import CertificateList from "../CertificateList/CertificateList";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";

// const Certificate = () => {
//   const [view, setView] = useState("form");
//   const [activeCert, setActiveCert] = useState(null);
//   const [editingCert, setEditingCert] = useState(null);
//   const [deleting, setDeleting] = useState(false);
//   const [showCertificateView, setShowCertificateView] = useState(false); // New state for certificate view toggle

//   const previewRef = useRef(null);
//   const downloadRef = useRef(null);
//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);

//   useEffect(() => {
//     const handleResize = () => setScreenWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const scale =
//     screenWidth >= 1920
//       ? 0.8
//       : screenWidth >= 1600
//         ? 0.7
//         : screenWidth >= 1400
//           ? 0.6
//           : screenWidth >= 1200
//             ? 0.5
//             : screenWidth >= 992
//               ? 0.25
//               : 0.15;

//   const handleSaved = (savedCertificate) => {
//     setActiveCert(savedCertificate);
//     setEditingCert(null);
//     setView("preview");
//     setShowCertificateView(true);
//   };

//   const handleEditClick = (cert) => {
//     setEditingCert(cert);
//     setView("form");
//     setShowCertificateView(false);
//   };

//   const handleCancelEdit = () => {
//     setEditingCert(null);
//     setView(activeCert ? "preview" : "list");
//     setShowCertificateView(!!activeCert);
//   };

//   const handleDelete = async () => {
//     if (!activeCert) return;
//     if (!window.confirm("Delete this certificate? This cannot be undone."))
//       return;

//     setDeleting(true);
//     try {
//       const res = await fetch(
//         `/api/certificates/${activeCert.certId}`,
//         { method: "DELETE" },
//       );
//       if (!res.ok) throw new Error("Failed to delete certificate");
//       setActiveCert(null);
//       setView("list");
//       setShowCertificateView(false);
//     } catch (err) {
//       alert(err.message || "Failed to delete certificate.");
//     } finally {
//       setDeleting(false);
//     }
//   };

//   const handleDownload = async () => {
//     if (!downloadRef.current || !activeCert) return;
//     const canvas = await html2canvas(downloadRef.current, {
//       scale: 2,
//       useCORS: true,
//       backgroundColor: "#ffffff",
//       windowWidth: downloadRef.current.scrollWidth,
//       windowHeight: downloadRef.current.scrollHeight,
//     });
//     const imgData = canvas.toDataURL("image/png");
//     const orientation = canvas.width > canvas.height ? "landscape" : "portrait";
//     const pdf = new jsPDF({
//       orientation,
//       unit: "px",
//       format: [canvas.width, canvas.height],
//     });
//     pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
//     pdf.save(`${activeCert.studentName.replace(/\s+/g, "_")}_certificate.pdf`);
//   };

//   const handleCloseCertificateView = () => {
//     setShowCertificateView(false);
//     setView("list");
//     setActiveCert(null);
//   };

//   return (
//     <div>
//       <div className=" ctm-border-radius shadow-sm bg-white  grow mb-3">
//           <div >
//           <ul 
//            style={{
//                 width: "100vw",
//                 display: "flex",
//                 gap: "0.5rem",
               
//                 flexWrap: "wrap",
//                 alignItems: "center",
//                 padding: "0.5rem",
//                 borderRadius: "0.5rem",

//               }}
//           >
//             <li
//               className={`list-group-item w-full flex text-center button-5 ${view === "form" ? "active" : ""}`}
             
//             >
//               <a
//                 href="#"
//                 className={view === "form" ? "text-white whitespace-nowrap" : "text-dark whitespace-normal"}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   setEditingCert(null);
//                   setView("form");
//                   setShowCertificateView(false);
//                 }}
//                 style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
//               >
//                 <FaCertificate /> Add Student
//               </a>
//             </li>
//             <li
//               className={`list-group-item text-center button-6 ${view === "list" ? "active" : ""}`}
//             >
//               <a
//                 href="#"
//                 className={view === "list" ? "text-white" : "text-dark"}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   setView("list");
//                   setShowCertificateView(false);
//                 }}
//                 style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
//               >
//                 <FaCertificate /> All Certificates
//               </a>
//             </li>
//           </ul>
//         </div>
//       </div>

//       {view === "form" && (
//         <AddCertificateForm
//           onSaved={handleSaved}
//           initialData={editingCert}
//           onCancel={editingCert ? handleCancelEdit : undefined}
//         />
//       )}

//       {view === "preview" && activeCert && showCertificateView && (
//         <div>
//           <div className="card-body text-center">
//             <div className="flex justify-between items-center mb-4">
//               <h4 className="text-dark mb-0">Preview & Generate Certificate</h4>
//               <button
//                 className="bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium py-2 px-4 rounded-lg transition-colors"
//                 onClick={handleCloseCertificateView}
//               >
//                 Close ✕
//               </button>
//             </div>

//             <div
//               className="mx-auto"
//               style={{
//                 width: `${1493 * scale}px`,
//                 height: `${1057 * scale}px`,
//                 overflow: "hidden",
//               }}
//             >
//               <div
//                 style={{
//                   transform: `scale(${scale})`,
//                   transformOrigin: "top left",
//                 }}
//               >
//                 <CertificateTemplate data={activeCert} ref={previewRef} />
//               </div>
//             </div>

//             <div
//               style={{ zoom: screenWidth < 600 ? "70%" : "100%" }}
//               className="flex *:text-sm w-screen flex-wrap items-center justify-center gap-x-3 mt-4"
//             >
//               <button
//                 className="border border-gray-300 hover:bg-gray-100 text-gray-800 font-medium py-2 px-4 rounded-lg whitespace-nowrap transition-colors"
//                 onClick={handleDownload}
//               >
//                 Download Certificate
//               </button>
//               <button
//                 className="border border-amber-400 hover:bg-amber-50 text-amber-700 font-medium py-2 px-4 rounded-lg whitespace-nowrap transition-colors"
//                 onClick={() => handleEditClick(activeCert)}
//               >
//                 Edit
//               </button>
//               <button
//                 className="border border-red-400 hover:bg-red-50 text-red-700 font-medium py-2 px-4 rounded-lg whitespace-nowrap transition-colors disabled:opacity-50"
//                 onClick={handleDelete}
//                 disabled={deleting}
//               >
//                 {deleting ? "Deleting..." : "Delete"}
//               </button>
//               <button
//                 className="border border-gray-300 hover:bg-gray-100 text-gray-800 font-medium py-2 px-4 rounded-lg whitespace-nowrap transition-colors"
//                 onClick={() => {
//                   setEditingCert(null);
//                   setView("form");
//                   setShowCertificateView(false);
//                 }}
//               >
//                 Add Student
//               </button>
//             </div>
//           </div>

//           <div
//             style={{ position: "fixed", top: 0, left: "-99999px", zIndex: -1 }}
//             aria-hidden="true"
//           >
//             <CertificateTemplate data={activeCert} ref={downloadRef} />
//           </div>
//         </div>
//       )}

//       {view === "list" && (
//         <CertificateList
//           onSelect={(cert) => {
//             setActiveCert(cert);
//             setView("preview");
//             setShowCertificateView(true);
//           }}
//           onEdit={handleEditClick}
//         />
//       )}
//     </div>
//   );
// };

// export default Certificate;



///
import React, { useState, useRef, useEffect } from "react";
import { FaCertificate, FaUserGraduate } from "react-icons/fa";
import { BsBank2 } from "react-icons/bs";
import { Link } from "react-router-dom";
import AddCertificateForm from "../AddCertificateForm/AddCertificateForm";
import CertificateTemplate from "../CertificateTemplate/CertificateTemplate";
import CertificateList from "../CertificateList/CertificateList";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const Certificate = () => {
  const [view, setView] = useState("form");
  const [activeCert, setActiveCert] = useState(null);
  const [editingCert, setEditingCert] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [showCertificateView, setShowCertificateView] = useState(false); // New state for certificate view toggle

  const previewRef = useRef(null);
  const downloadRef = useRef(null);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const scale =
    screenWidth >= 1920
      ? 0.8
      : screenWidth >= 1600
        ? 0.7
        : screenWidth >= 1400
          ? 0.6
          : screenWidth >= 1200
            ? 0.5
            : screenWidth >= 992
              ? 0.25
              : 0.15;

  const handleSaved = (savedCertificate) => {
    setActiveCert(savedCertificate);
    setEditingCert(null);
    setView("preview");
    setShowCertificateView(true);
  };

  const handleEditClick = (cert) => {
    setEditingCert(cert);
    setView("form");
    setShowCertificateView(false);
  };

  const handleCancelEdit = () => {
    setEditingCert(null);
    setView(activeCert ? "preview" : "list");
    setShowCertificateView(!!activeCert);
  };

  const handleDelete = async () => {
    if (!activeCert) return;
    if (!window.confirm("Delete this certificate? This cannot be undone."))
      return;

    setDeleting(true);
    try {
      const res = await fetch(
        `/api/certificates/${activeCert.certId}`,
        { method: "DELETE" },
      );
      if (!res.ok) throw new Error("Failed to delete certificate");
      setActiveCert(null);
      setView("list");
      setShowCertificateView(false);
    } catch (err) {
      alert(err.message || "Failed to delete certificate.");
    } finally {
      setDeleting(false);
    }
  };

  const handleDownload = async () => {
    if (!downloadRef.current || !activeCert) return;
    const canvas = await html2canvas(downloadRef.current, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      windowWidth: downloadRef.current.scrollWidth,
      windowHeight: downloadRef.current.scrollHeight,
    });
    const imgData = canvas.toDataURL("image/png");
    const orientation = canvas.width > canvas.height ? "landscape" : "portrait";
    const pdf = new jsPDF({
      orientation,
      unit: "px",
      format: [canvas.width, canvas.height],
    });
    pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
    pdf.save(`${activeCert.studentName.replace(/\s+/g, "_")}_certificate.pdf`);
  };

  const handleCloseCertificateView = () => {
    setShowCertificateView(false);
    setView("list");
    setActiveCert(null);
  };

  return (
    <div className="inner-wrapper" style={{ marginTop: "30px" }}>
      <div className="page-wrapper" style={{ marginTop: "-70px" }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-3 col-lg-4 col-md-12 theiaStickySidebar">
              <aside className="sidebar sidebar-user">
                <div className="user-card card shadow-sm bg-white text-center ctm-border-radius grow" style={{ width: "290px" }}>
                  <div className="user-info card-body">
                    <div className="user-avatar mb-4">
                      <img src="images/408535-200.png" alt="User Avatar" className="img-fluid rounded-circle" width="100" />
                    </div>
                    <div className="user-details">
                      <h2>Welcome Admin!</h2>
                    </div>
                  </div>
                </div>
                <div className="sidebar-wrapper">
                  <div className="card ctm-border-radius shadow-sm border-none grow navbars" style={{ width: "290px" }}>
                    <div className="card-body">
                      <div className="row no-gutters">
                        <div className="col-12 col-md-6 align-items-center shadow-none text-center">
                          <Link to="/admincarrers" className="text-dark p-4 second-slider-btn ctm-border-right ctm-border-top">
                            <span className="lnr font-23"><FaUserGraduate /></span>
                            <span className="nav-text">Careers</span>
                          </Link>
                        </div>
                        <div className="col-12 col-md-6 align-items-center shadow-none text-center">
                          <Link to="/expenses" className="text-dark p-4 second-slider-btn ctm-border-right ctm-border-top">
                            <span className="lnr font-23"><BsBank2 /></span>
                            <span className="nav-text">Expenses</span>
                          </Link>
                        </div>
                        <div className="col-12 col-md-4 align-items-center shadow-none text-center">
                          <Link to="/certificate" className="text-dark p-4 second-slider-btn ctm-border-right ctm-border-top">
                            <span className="lnr font-23"><FaCertificate /></span>
                            <span className="nav-text">Certificate</span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </aside>
            </div>

            <div className="col-xl-9 col-lg-8 col-md-12">
              <div className="col-lg-9 col-md-9">
                <div className="content-area">

                  {/* ===== everything below this line is your original, unchanged JSX ===== */}
                  <div>
                    <div className="py-10 ctm-border-radius mt-10 shadow-sm bg-white  grow mb-3">
                        <div  style={{
                          marginTop:20,
                          padding: 10,

                        }}>
                        <ul 
                         style={{
                              width: "100vw",
                              display: "flex",
                              gap: "0.5rem",
                             
                              flexWrap: "wrap",
                              alignItems: "center",
                              padding: "0.5rem",
                              borderRadius: "0.5rem",

                            }}
                        >
                          <li
                            className={`list-group-item w-full flex text-center button-5 ${view === "form" ? "active" : ""}`}
                           
                          >
                            <a
                              href="#"
                              className={view === "form" ? "text-white whitespace-nowrap" : "text-dark whitespace-normal"}
                              onClick={(e) => {
                                e.preventDefault();
                                setEditingCert(null);
                                setView("form");
                                setShowCertificateView(false);
                              }}
                              style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                            >
                              <FaCertificate /> Add Student
                            </a>
                          </li>
                          <li
                            className={`list-group-item text-center button-6 ${view === "list" ? "active" : ""}`}
                          >
                            <a
                              href="#"
                              className={view === "list" ? "text-white" : "text-dark"}
                              onClick={(e) => {
                                e.preventDefault();
                                setView("list");
                                setShowCertificateView(false);
                              }}
                              style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                            >
                              <FaCertificate /> All Certificates
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>

                    {view === "form" && (
                      <AddCertificateForm
                        onSaved={handleSaved}
                        initialData={editingCert}
                        onCancel={editingCert ? handleCancelEdit : undefined}
                      />
                    )}

                    {view === "preview" && activeCert && showCertificateView && (
                      <div>
                        <div className="card-body text-center">
                          <div className="flex justify-between items-center mb-4">
                            <h4 className="text-dark mb-0">Preview & Generate Certificate</h4>
                            <button
                              className="bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium py-2 px-4 rounded-lg transition-colors"
                              onClick={handleCloseCertificateView}
                            >
                              Close ✕
                            </button>
                          </div>

                          <div
                            className="mx-auto"
                            style={{
                              width: `${1493 * scale}px`,
                              height: `${1057 * scale}px`,
                              overflow: "hidden",
                            }}
                          >
                            <div
                              style={{
                                transform: `scale(${scale})`,
                                transformOrigin: "top left",
                              }}
                            >
                              <CertificateTemplate data={activeCert} ref={previewRef} />
                            </div>
                          </div>

                          <div
                            style={{ zoom: screenWidth < 600 ? "70%" : "100%" }}
                            className="flex *:text-sm w-screen flex-wrap items-center justify-center gap-x-3 mt-4"
                          >
                            <button
                              className="border border-gray-300 hover:bg-gray-100 text-gray-800 font-medium py-2 px-4 rounded-lg whitespace-nowrap transition-colors"
                              onClick={handleDownload}
                            >
                              Download Certificate
                            </button>
                            <button
                              className="border border-amber-400 hover:bg-amber-50 text-amber-700 font-medium py-2 px-4 rounded-lg whitespace-nowrap transition-colors"
                              onClick={() => handleEditClick(activeCert)}
                            >
                              Edit
                            </button>
                            <button
                              className="border border-red-400 hover:bg-red-50 text-red-700 font-medium py-2 px-4 rounded-lg whitespace-nowrap transition-colors disabled:opacity-50"
                              onClick={handleDelete}
                              disabled={deleting}
                            >
                              {deleting ? "Deleting..." : "Delete"}
                            </button>
                            <button
                              className="border border-gray-300 hover:bg-gray-100 text-gray-800 font-medium py-2 px-4 rounded-lg whitespace-nowrap transition-colors"
                              onClick={() => {
                                setEditingCert(null);
                                setView("form");
                                setShowCertificateView(false);
                              }}
                            >
                              Add Student
                            </button>
                          </div>
                        </div>

                        <div
                          style={{ position: "fixed", top: 0, left: "-99999px", zIndex: -1 }}
                          aria-hidden="true"
                        >
                          <CertificateTemplate data={activeCert} ref={downloadRef} />
                        </div>
                      </div>
                    )}

                    {view === "list" && (
                      <CertificateList
                        onSelect={(cert) => {
                          setActiveCert(cert);
                          setView("preview");
                          setShowCertificateView(true);
                        }}
                        onEdit={handleEditClick}
                      />
                    )}
                  </div>
                  {/* ===== end of your original JSX ===== */}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sidebar-overlay" id="sidebar_overlay"></div>
    </div>
  );
};

export default Certificate;